import React, { useState } from "react";
import "./styles.scss";
import { Modal, Backdrop } from "@mui/material";
import { Clear } from "@mui/icons-material";

import { useStateValue } from "../../../store";
import Button from "../../../common/button";

const ServicePopupModal = (props) => {
  const [{ servicePopup }, dispatch] = useStateValue();

  const [open, setOpen] = React.useState(true);
  // const handleClose = (event, reason) => {
  //   if (reason && reason === "backdropClick") return;
  //   else {
  //     setOpen(false);
  //     dispatch({
  //       type: "SET_IS_SERVICE_POPUP",
  //       value: false,
  //       data: data,
  //       apiData: {},
  //     });
  //   }
  // };
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      // onClose={handleClose}
      disableAutoFocus={true}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className="service-popup-container"
    >
      <div className="popup-container">
        {/* <div className="title">
          <Clear className="clear-btn" onClick={() => handleClose()} />
        </div> */}

        <div className="add-message">{servicePopup?.apiData}</div>
        <div className="service-section">
          <Button
            onClick={() => {
              dispatch({
                type: "SET_IS_SERVICE_POPUP",
                value: false,
                data: true,
                apiData: "",
              });
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              dispatch({
                type: "SET_IS_SERVICE_POPUP",
                value: false,
                data: false,
                apiData: "",
              });
            }}
          >
            No
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ServicePopupModal;
